import { useContext, useMemo } from "react";
import { matchPath, useLocation } from "react-router";
import { NavLink } from "react-router-dom";

import { GlobalContext } from "#/context";
import { modifyLast } from "#/utils/ArrayUtils";

export const resolvers = {
  entity: "entity",
};

export default function BreadCrumbs() {
  const { pathname } = useLocation();
  const [{ breadcrumbs } = { breadcrumbs: [] }] = useContext(GlobalContext);

  const entity = { id: "123", name: "Entity" };

  function resolve(resolver, match, name) {
    if (resolver && String(entity.id) === String(match.params.entityId)) {
      return entity.name || name;
    }

    return name;
  }

  const crumbs = useMemo(() => {
    return modifyLast(
      breadcrumbs.reduce((result, route) => {
        const match = matchPath(
          { path: route.fullPath, end: route.end },
          pathname
        );
        if (match) {
          if (route.name) {
            result.push({
              url: match.pathname,
              name: resolve(route.resolver, match, route.name),
              active: match.pathname === pathname,
              resolver: route.resolver,
            });
          } else {
            //if we have a matching URL without a name (no breadcrumb) we set current URL to previous breadcrumb. This way we can handle tabs
            modifyLast(result, (previous) => (previous.url = match.pathname));
          }
        }
        return result;
      }, []),
      (last) => (last.active = true)
    );
  }, [breadcrumbs, pathname]);

  return (
    <nav className="breadcrumb" aria-label="breadcrumbs">
      <ul>
        {crumbs.map(({ url, resolver, active, name }) => (
          <li key={url}>
            <NavLink
              to={url}
              className={() =>
                `${resolver ? "has-max-width" : ""}${
                  active ? " is-active" : ""
                }`
              }>
              {name}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
